import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AvisoPrivacidad from './components/AvisoPrivacidad';
import ServiceERP from './components/ServiceERP'; // <--- AGREGA ESTA LÍNEA (Verifica si es ./pages/ o ./components/)
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/aviso-de-privacidad" element={<AvisoPrivacidad />} />
          <Route path="/erp" element={<ServiceERP />} /> {/* Ahora 'ServiceERP' ya está definido */}
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
